export default function findElementById(
    { elementId, shadowRootToSearch, webComponentTagToSearch }:
    { elementId: string, shadowRootToSearch?: ShadowRoot|null, webComponentTagToSearch?: string|null }
    ): Element|null {
    if (shadowRootToSearch) {
        const element = shadowRootToSearch.getElementById(elementId)
        if (element) return element;
    }
    if (webComponentTagToSearch) {
        const element = document.querySelector(webComponentTagToSearch)?.shadowRoot?.getElementById(elementId)
        if (element) return element;
    }
    if (!!elementId) {
        const element = document.getElementById(elementId);
        if (element) return element;
    }
    return null;
}
